import { gql } from "@apollo/client";

export const GetCycles = gql`
  query GetCycles($filters: [FilterObject!]) {
    userAssessmentCycles(filters: $filters) {
      data {
        id
        bhiRefactorPillarScores {
          pillarName
          value
          bhiRefactorUserAssessments {
            name
            scores {
              scoreName
              scoreType
              value
            }
          }
        }
        cycleCompletionDate
        cycleNumber
      }
    }
  }
`;

export const GetUserAssessmentCycleIdsAndNumbers = gql`
  query AssessmentCyclesByParticipantId($filters: [FilterObject!], $sort: OrderObject!) {
    userAssessmentCycles(filters: $filters, sort: $sort) {
      data {
        id
        cycleNumber
        status
      }
    }
  }
`;
